const userDefaults = {
    timeSince: null,
    gender: null,
    isKaiserMember: null,
    isFpactHolder: null,
    location: {
        lat: null,
        long: null
    }
}

const userReducer = (state = userDefaults, action) => {
    switch(action.type) {
        case 'SET_GENDER': {
            return { ...state, gender: action.payload }
        }
        case 'SET_TIME_SINCE': {
            return { ...state, timeSince: action.payload }
        }
        case 'SET_KAISER': {
            return { ...state, isKaiserMember: action.payload }
        }
        case 'SET_FPACT': {
            return { ...state, isFpactHolder: action.payload }
        }
    }
    return state;
}

export default userReducer;


// WEBPACK FOOTER //
// ./src/reducers/user.js